/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GetAvailableProfessionDocumentsResponseData = {
  properties: {
    id: {
      type: 'string',
      isRequired: true,
    },
    type: {
      type: 'ProfessionDocumentType',
      isRequired: true,
    },
    description: {
      type: 'string',
    },
    allowedFileTypes: {
      type: 'array',
      contains: {
        type: 'string',
      },
      isRequired: true,
    },
    required: {
      type: 'boolean',
      isRequired: true,
    },
    groupName: {
      type: 'string',
      isRequired: true,
    },
    active: {
      type: 'boolean',
      isRequired: true,
    },
    longDescription: {
      type: 'string',
    },
    professionId: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
